module.exports = __webpack_public_path__ + "static/media/four.b8c918a1.svg";